/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Map_Popup_Routes_SubtitleInputs */

const en_ui_map_popup_routes_subtitle = /** @type {(inputs: Ui_Map_Popup_Routes_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routes near this location`)
};

const de_ui_map_popup_routes_subtitle = /** @type {(inputs: Ui_Map_Popup_Routes_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routen in der Nähe dieses Ortes`)
};

/**
* | output |
* | --- |
* | "Routes near this location" |
*
* @param {Ui_Map_Popup_Routes_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_map_popup_routes_subtitle = /** @type {((inputs?: Ui_Map_Popup_Routes_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Map_Popup_Routes_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_map_popup_routes_subtitle(inputs)
	return de_ui_map_popup_routes_subtitle(inputs)
});